export default {"src":"/_next/static/media/webhook.02932dc3.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};